$(document).ready(function () {
  $(document).on('click', '#advisor-ranker-page .toggle .toggle__pill', function () {
    const archivedRows = $('.sk-tab-container .table-ranker tr.inactive');
    if (archivedRows.hasClass('d-none')) archivedRows.removeClass('d-none');
    else archivedRows.addClass('d-none');
  })

  // Event listener for tab click in advisor ranker component
  $(document).on('click', '#advisor-ranker-page .sk-tab-container__header__tab', function () {
    $(this).addClass('active').siblings().removeClass('active');

    const rankerPage = $(this).closest('#advisor-ranker-page');
    const teamDropdown = rankerPage.find('.team-dropdown-js');
    const timelineDropDown = rankerPage.find('.timeline-dropdown-js');
    const toggle = rankerPage.find('.toggle-container')

    const isAdvisorRankTab = $(this).attr('content') === 'advisor_rank';
    const isTopGunTab = $(this).attr('content') === 'top_gun_rank';
    const isCraTab = $(this).attr('content') === 'cra_score_rank';
    const isTeamTab = $(this).attr('content') === 'team_rank';

    if (!(isAdvisorRankTab || isCraTab)) teamDropdown.addClass('d-none');
    else teamDropdown.removeClass('d-none');

    if (isTopGunTab) timelineDropDown.addClass('d-none');
    else timelineDropDown.removeClass('d-none');

    if (isTeamTab) toggle.addClass('d-none');
    else toggle.removeClass('d-none');
  });

  // Event listener for team selection change in advisor ranker component
  $(document).on('change', '#advisor-ranker-page .selected-team-js', function () {
    const form = $(this).closest('form');
    const activeTab = $('#advisor-ranker-page .sk-tab-container__header__tab.active').attr('content')
    $('input[name="selected_tab"]').val(activeTab);
    form[0].requestSubmit();
    // Submit the form to reload the page
    form[0].requestSubmit();
  });

  // Event listener for timeline selection change in advisor ranker component
  // If timeline is changed to 'Custom', show custom timeline submit button and don't reload the ranker
  // If timeline is changed to anything else, hide custom timeline submit button and reload the ranker
  $(document).on('change', '#advisor-ranker-page .selected-timeline-js', function () {
    const timeline = $(this).val();
    const form = $(this).closest('form');
    const activeTab = $('#advisor-ranker-page .sk-tab-container__header__tab.active').attr('content')
    $('input[name="selected_tab"]').val(activeTab);

    if (timeline === 'Custom') {
      $(this).closest('#advisor-ranker-page').find('.custom-timeline-dropdowns-js').removeClass('d-none');
    } else {
      $(this).closest('#advisor-ranker-page').find('.custom-timeline-dropdowns-js').addClass('d-none');
      // Submit the form to reload the page
      form[0].requestSubmit();
    }
  });

  // Event listener for custom timeline submit button click in advisor ranker component
  $(document).on('click', '#advisor-ranker-page .custom-timeline-submit-btn-js', function () {
    const form = $(this).closest('form');
    const activeTab = $('#advisor-ranker-page .sk-tab-container__header__tab.active').attr('content')
    $('input[name="selected_tab"]').val(activeTab);
    // Submit the form to reload the page
    form[0].requestSubmit();
  });
});
